import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tpt_lang") || "id");

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("tpt_lang", l);
  }, []);

  const toggle = useCallback(() => {
    setLanguage(lang === "id" ? "en" : "id");
  }, [lang, setLanguage]);

  // t("home.heroSub") -> string; loc(field) -> field[lang]
  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        cur = cur?.[p];
        if (cur == null) return path;
      }
      return cur;
    },
    [lang]
  );

  const loc = useCallback(
    (field) => {
      if (field == null) return "";
      if (typeof field === "string") return field;
      return field[lang] ?? field.en ?? field.id ?? "";
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLanguage, toggle, t, loc }), [lang, setLanguage, toggle, t, loc]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
